module.exports = __webpack_public_path__ + "img/58.39a25026.jpg";